// this role cannot be owner, because the owner cannot be a member of the org
// because all members of the org will have emails with the same domain as the org
export enum Role {
  admin = "Admin",
  member = "Member",
  // guest = "Guest",
}
